import { DEFAULT_EXPENSE_LINE_ITEM_QUANTITY, DEFAULT_EXPENSE_LINE_ITEM_UNIT_OF_MEASURE } from "~Features/pages/expenses/expenseInitializer"
import { type DeliveryNoteFormValues } from "../types/deliveryNote.interfaces"

export const createDefaultLineItem = (): Omit<Partial<DeliveryNoteFormValues["lineItems"][number]>, "_id"> => ({
    quantity: DEFAULT_EXPENSE_LINE_ITEM_QUANTITY,
    name: "",
    unitOfMeasure: DEFAULT_EXPENSE_LINE_ITEM_UNIT_OF_MEASURE,
    materialCode: "",
})
